module.exports = __webpack_public_path__ + "img/chat.ebbe46b4.png";